import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { RedButton, WhiteButton } from 'libs/ui';
import { WarningContainer, Content, Title, Buttons } from './confirm.styled';

let timer = null;
export const Confirm = ({ action, close, period, top = 76 }) => {
  const { t } = useTranslation();
  const [last, setLast] = useState(period);

  useEffect(() => {
    timer = setInterval(() => {
      setLast((cnt) => cnt - 1);
      if (last === 0) {
        clearInterval(timer);
      }
    }, 1000);
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, []);

  return (
    <WarningContainer style={{ top: `${top}px` }}>
      <Content>
        <Title>{t('windows.Внимание')}</Title>
        <p>{t('windows.Оборудование будет перезагружено и недоступно некоторое время Продолжить')}?</p>
        <Buttons>
          <WhiteButton onClick={close}>{t('buttons.Отмена')}</WhiteButton>
          <RedButton disabled={last > 0} onClick={action}>
            {t('buttons.Перезагрузка')}&nbsp;
            {last > 0 && (
              <span>
                ( {last} {t('windows.с')}. )
              </span>
            )}
          </RedButton>
        </Buttons>
      </Content>
    </WarningContainer>
  );
};

Confirm.propTypes = {
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  period: PropTypes.number,
};
